import TablePageListBase from './tablePageListBase.vue';

export default TablePageListBase;
